import fetch from "auth/FetchInterceptor";

const EventsService = {};

const eventsPrefix = "/events";

EventsService.getEvents = async () =>
  await fetch(`${eventsPrefix}/bo`, {
    method: "GET",
  });

EventsService.getEventById = async (id) =>
  await fetch(`${eventsPrefix}/${id}`, {
    method: "GET",
  });

EventsService.createEvent = async (data) =>
  await fetch(`${eventsPrefix}`, {
    method: "POST",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

EventsService.updateEvent = async (id, data) =>
  await fetch(`${eventsPrefix}/${id}`, {
    method: "PATCH",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

EventsService.deleteEvent = async (id) =>
  await fetch(`${eventsPrefix}/${id}`, {
    method: "DELETE",
  });

export default EventsService;
